import styled from 'styled-components';

export const Header = styled.header`
  width: 100%;
  height: 65px;
  padding: 0 30px;
  background-color: #454f63;
  display: ${(props) => (props.loginDisplay ? 'none' : 'flex')};
  justify-content: space-between;
  align-items: center;

  @media (max-width: 759px) {
    height: 80px;
    padding: 0 20px;
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
`;

export const Title = styled.h1`
  font-size: 18px;
  text-align: center;
  letter-spacing: 0.27px;
  color: #fff;
  opacity: 1;
  font-weight: normal;
  flex: 1;

  @media (max-width: 759px) {
    display: none;
  }
`;

export const TitleMobile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  opacity: 1;
  background-color: #025a9c14;
  font-size: 20px;
  font-weight: normal;
  color: #455063;

  @media (min-width: 760px) {
    display: none;
  }
`;

export const PerfilContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
`;

export const LoginTitle = styled.a`
  text-align: right;
  font-size: 14px;
  letter-spacing: 0px;
  color: #fff;
  opacity: 1;
  margin-right: 10px;
`;
export const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f9f9fb;
  opacity: 1;
`;

export const ButtonNewConsult = styled.button`
  width: 171px;
  height: 35px;
  border: 1px solid var(--unnamed-color-ffffff);
  border: 1px solid #ffffff;
  border-radius: 4px;
  opacity: 1;
  background-color: #454f63;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #ffffff;
  text-transform: uppercase;
  opacity: 1;
  margin-right: 30px;

  svg {
    display: none;
  }

  @media (max-width: 759px) {
    width: auto;
    height: auto;
    border: none;
    margin: 0;
    p {
      display: none;
    }

    svg {
      display: block;
    }
  }
`;
